import {SET_NOTIFICATIONS} from "@/core/store/modules/notification/constants";

export default {
    [SET_NOTIFICATIONS](state, data) {
        state.groups = data.groups
        state.notifications = data.notifications
        state.payment = data.payment
        state.total = data.total
        state.login_as_client = data.login_as_client
    },

}